import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, memo } from 'react';
import ArrowLink from 'Common/components/ArrowLink/ArrowLink';
import Link from 'Common/components/Link/Link';
import TableCellLink from 'Common/components/Table/components/TableCellLink/TableCellLink';
import { hasQVVariantsLinks } from 'Common/utils';
import { ANCESTRIES } from 'Common/types';
import useRouter from 'Router/index';
export const DEFAULT_LINKS_LABEL = 'view variants >';
const LinkToQVView = ({ datasetVersionId, geneId, phenotypeId, collapsingModelId, phenotypicCategoryId, traitsType, label, title, ancestry, hasArrow, pvalue, cases, referrerData, placeholderLabel, handleClick, }) => {
    const { getPath, getLocation } = useRouter();
    const { pathname } = getLocation();
    const QVViewPath = useMemo(() => (getPath(2 /* QVView */, {
        ancestryEnum: ancestry ? ANCESTRIES[ancestry] : '',
        datasetVersionId,
        geneId,
        phenotypeId,
        collapsingModelId,
        phenotypicCategoryId,
        traitsType,
    })), [
        ancestry,
        datasetVersionId,
        geneId,
        phenotypeId,
        collapsingModelId,
        phenotypicCategoryId,
        traitsType,
        getPath,
    ]);
    const route = useMemo(() => ({
        pathname: QVViewPath,
        state: {
            referrerURI: pathname,
            referrerData,
        },
    }), [QVViewPath, pathname, referrerData]);
    const hasVariants = hasQVVariantsLinks(traitsType, pvalue, cases);
    if (!hasVariants) {
        return placeholderLabel
            ? _jsx("span", { children: placeholderLabel }, void 0)
            : null;
    }
    if (!label) {
        return (_jsx(Link, Object.assign({ to: route, title: "view variants", onClick: handleClick }, { children: DEFAULT_LINKS_LABEL }), void 0));
    }
    return hasArrow
        ? (_jsx(ArrowLink, Object.assign({ route: route, title: title, handleClick: handleClick }, { children: label }), void 0))
        : (_jsx(TableCellLink, { route: route, label: label, title: title }, void 0));
};
export default memo(LinkToQVView);
